<template>
  <VApp>
    <NuxtPage />
  </VApp>
</template>
